/* eslint-disable max-lines*/
/* eslint-disable array-element-newline */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-no-bind */
import React, {useState} from "react";
import CartAPI from "../../shared/modules/CartAPI";
import CartHeader from "./CartHeader";
import InputField from "../../shared/components/InputField";
import LoadingSpinner from "../BuyItNow/components/LoadingSpinner";
import PropTypes from "prop-types";
import StateField from "../../shared/components/StateField";

const AddressInfoForm = ({
  addressInfo,
  setAddresses,
  setAddressInfo,
  setDisplayErrors,
  setError,
  setIsEditingAddress,
  setVerificationStep
}) => {
  const {
    "first_name": existingFirstName,
    "last_name": existingLastName,
    "street_address_1": streetAddressOne,
    "street_address_2": streetAddressTwo
  } = addressInfo;

  const [firstName, setFirstName] = useState(existingFirstName);
  const [lastName, setLastName] = useState(existingLastName);
  const [streetAddress, setStreetAddress] = useState(streetAddressOne);
  const [unitNumber, setUnitNumber] = useState(streetAddressTwo);
  const [city, setCity] = useState(addressInfo.city);
  const [state, setState] = useState(addressInfo.state);
  const [zipCode, setZipCode] = useState(addressInfo.zip);
  const [phone, setPhone] = useState(addressInfo.phone);

  const [isLoading, setIsLoading] = useState(false);

  const handleErrorAfterVerification = (response) => {
    setAddresses({"enteredAddress": response.responseJSON.entered_address});
    setIsLoading(false);
    setVerificationStep(true);
  };

  const handleSuccessAfterVerification = (response) => {
    setAddresses({
      "enteredAddress": response.entered_address,
      "verifiedAddress": response.verified_address
    });
    setVerificationStep(true);
  };

  const submitShippingInfo = (event) => {
    event.preventDefault();
    setIsLoading(true);

    const address = {
      city,
      firstName,
      lastName,
      phone,
      state,
      streetAddress,
      unitNumber,
      zipCode
    };

    const validateAddress = () => {
      if (
        streetAddress &&
        city &&
        firstName &&
        lastName &&
        phone &&
        state &&
        zipCode
      ) {
        return true;
      }
      return false;
    };

    if (validateAddress()) {
      setAddressInfo({
        city,
        "first_name": firstName,
        "last_name": lastName,
        phone,
        state,
        "street_address_1": streetAddress,
        "street_address_2": unitNumber,
        "zip": zipCode
      });
      CartAPI.verifyAddress(address, handleSuccessAfterVerification, handleErrorAfterVerification);
    } else {
      setIsLoading(false);
      setError({"message": "Please fill out all required fields"});
      setDisplayErrors(true);
    }
  };

  const handleGoBack = () => {
    setIsEditingAddress(false);
  };

  const handleChangeInput = setStateFn => event => setStateFn(event.target.value);

  const renderForm = () => (
    <form
      className="address-form"
      onSubmit={submitShippingInfo}
    >
      <InputField
        className="name-field"
        id="name-field-input"
        label="First Name"
        onChange={handleChangeInput(setFirstName)}
        required
        value={firstName}
      />
      <InputField
        className="name-field"
        id="name-field-input"
        label="Last Name"
        onChange={handleChangeInput(setLastName)}
        required
        value={lastName}
      />

      <InputField
        className="address-line-one-field"
        id="address-line-one-field-input"
        label="Address line 1"
        onChange={handleChangeInput(setStreetAddress)}
        required
        value={streetAddress}
      />
      <InputField
        className="address-line-two-field"
        id="address-line-two-field-input"
        label="Address line 2"
        onChange={handleChangeInput(setUnitNumber)}
        value={unitNumber}
      />
      <InputField
        className="city-field"
        id="city-field-input"
        label="City"
        onChange={handleChangeInput(setCity)}
        required
        value={city}
      />
      <div className="state-field">
        <StateField
          changeHandler={handleChangeInput(setState)}
          label="State"
          labelAdditionalClassName="input-field-label"
          required
          selectClassName="input-field-input"
          selectId="state-field-input"
          state={state}
        />
      </div>
      <InputField
        className="zip-field"
        id="zip-field-input"
        label="Zip code"
        onChange={handleChangeInput(setZipCode)}
        required
        value={zipCode}
      />
      <div className="country-field">
        <label className="input-field-label">
          &nbsp;
        </label>
        <div className="country-field-value">
          United States
        </div>
      </div>
      <InputField
        className="phone-field"
        id="phone-field-input"
        label="Mobile number"
        onChange={handleChangeInput(setPhone)}
        type="tel"
        value={phone}
      />
      <button
        className="btn btn-primary cart-save-button"
        disabled={isLoading}
        type="submit"
      >
        {isLoading ? <LoadingSpinner /> : "Save"}
      </button>
    </form>
  );

  return (
    <div className="address-info-edit">
      <CartHeader
        classes="justify-start items-start gap-2.5 -mx-5 text-lg"
        handleBackButton={handleGoBack}
        showBackButton
        title="edit shipping address"
      />
      {renderForm()}
    </div>
  );
};

AddressInfoForm.propTypes = {
  "addressInfo": PropTypes.object.isRequired,
  "setAddressInfo": PropTypes.func.isRequired,
  "setAddresses": PropTypes.func.isRequired,
  "setDisplayErrors": PropTypes.func.isRequired,
  "setError": PropTypes.func.isRequired,
  "setIsEditingAddress": PropTypes.func.isRequired,
  "setVerificationStep": PropTypes.func.isRequired
};

AddressInfoForm.defaultProps = {"shippingAddress": {}};

export default AddressInfoForm;
